export default __webpack_public_path__ + "static/media/004.3e6bc153.jpg";